<template>
  <v-list-item @click="open">
    <v-list-item-avatar>
      <v-icon small color="secondary">fal fa-plus</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title class="secondary--text">語学力を追加する</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action class="text-xs-right">
      <v-btn text :disabled="true"></v-btn>
    </v-list-item-action>
    <v-dialog scrollable v-model="config.status.active" max-width="600">
      <v-card>
        <v-card-title class="primary amber blue-grey--text text--darken-4">
          <span class="headline">渡航歴を追加</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-row dense>
                <v-col cols="12" class="px-3">
                  <v-select
                    v-model="form.lang"
                    label="言語"
                    item-text="text"
                    item-value="value"
                    :rules="rules.lang"
                    :items="getLangItems"
                  />
                </v-col>
                <v-col cols="12" class="px-3">
                  <v-select
                    v-model="form.level"
                    label="自己申告の語学レベル"
                    :rules="rules.level"
                    :items="getLevelItems"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn text
            color="secondary"
            @click="close">閉じる</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="secondary"
            :disabled="!isValid"
            :loading="isLoading"
            @click="submit">追加する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-item>
</template>

<script>
export default {
  name: 'insert-modal',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        }
      },
      meta: {
        levels: [
          '入門', '初級', '中級（下）', '中級', '中級（上）', '上級'
        ]
      },
      form: {
        valid: true,
        lang: '',
        level: ''
      },
      rules: {
        lang: [
          v => !!v || '必須項目です'
        ],
        level: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this, 'form', {
        valid: true,
        lang: 'english',
        level: ''
      })
    },
    open: function () {
      this.init()
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'about/insert/meta', {
            cid: this.$route.params.id,
            mtype: 'about.lang',
            form: {
              lang: this.form.lang,
              level: this.form.level
            }
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('emit', {
                action: 'insert',
                data: {
                  type: 'langs',
                  resolve: res.data.data
                }
              })
            }
            this.$set(this.config.status, 'loading', false)
            this.$set(this.config.status, 'active', false)
          })
        })
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    getLangItems () {
      return Object.keys(this.$mango.about.langs).map(key => {
        return {
          text: this.$mango.about.langs[key],
          value: key
        }
      })
    },
    getLevelItems () {
      return this.meta.levels
    }
  }
}
</script>
